import { render, staticRenderFns } from "./PageMainNews.vue?vue&type=template&id=2162316a&scoped=true&"
import script from "./PageMainNews.vue?vue&type=script&lang=js&"
export * from "./PageMainNews.vue?vue&type=script&lang=js&"
import style0 from "./PageMainNews.vue?vue&type=style&index=0&id=2162316a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2162316a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VIcon})
